import { useNavigate } from 'react-router';
import { useAuth } from '../../auth/AuthContext';
import type { KpiProfile } from '../../lib/kpi';
import { Button } from '../../components/ui/Button';
import { formatDay, formatHour } from './format';

type Props = {
  profile: KpiProfile;
};

export function DashboardHeader({ profile }: Props) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  async function signOut() {
    await logout();
    navigate('/login', { replace: true });
  }

  return (
    <header className="border-b border-[var(--co-border)] bg-[var(--co-surface)]">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-3">
        <div>
          <h1 className="text-lg font-semibold">REPACKZ KPI</h1>
          <p className="text-xs text-[var(--co-muted)]">
            Figures through {formatDay(profile.published_through)} · a new day appears at{' '}
            {formatHour(profile.publish_hour_utc)} · days are UTC
          </p>
          <p className="text-xs text-[var(--co-muted)]">
            Past days can still change, e.g. when a delivery falls through after the fact.
          </p>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm text-[var(--co-muted)]">{profile.email}</span>
          <Button variant="ghost" onClick={() => void signOut()}>
            Sign out
          </Button>
        </div>
      </div>
    </header>
  );
}
